import { makeStyles } from 'tss-react/mui';

import { darkOrLightStyle } from '@/utils/styles';

export const WAYFINDING_CARD_WIDTH = 260;

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props, 'cardImage' | 'cardLink'>({
  name: 'Wayfinding',
  uniqId: 'lZ3h28',
})(
  (
    { brandColors, spacing, breakpoints, aspectRatio, typography },
    props,
    classes
  ) => ({
    container: {
      overflow: 'hidden',
      '&.OnDark': {
        backgroundColor: brandColors.tintsHeroBlue10,
      },
      '&.OnLight': {
        backgroundColor: brandColors.tintsOffWhite60,
      },
    },
    grid: {
      '& .swiper': {
        overflow: 'visible',
      },
    },
    cardContainer: {
      marginTop: spacing(3),
    },
    card: {
      display: 'block',
      textDecoration: 'none',
      width: typography.pxToRem(WAYFINDING_CARD_WIDTH),
      cursor: 'pointer',
      '&:hover, &:focus': {
        [`& .${classes.cardImage}`]: {
          transform: 'scale(1.1)',
        },
        [`& .${classes.cardLink}`]: {
          '&.OnDark': {
            color: brandColors.offWhite,
          },
          '&.OnLight': {
            color: brandColors.primaryMain,
          },
        },
      },
    },
    cardImageContainer: {
      overflow: 'hidden',
      marginBottom: spacing(2),
      borderRadius: typography.pxToRem(16),
    },
    cardImageContainerEyebrow: {
      marginBottom: spacing(1),
    },
    cardImage: {
      aspectRatio: aspectRatio['1/1'],
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
      transition: 'transform .5s',
    },
    cardLink: {
      fontWeight: 500,
      textDecoration: 'underline',
      '&.OnDark': {
        color: brandColors.white,
      },
      '&.OnLight': {
        color: brandColors.mediumBlue,
      },
    },
    cardLinkEyebrow: { marginTop: spacing(-1) },
    cardBody: {
      marginTop: spacing(0),
      '&.OnDark': {
        color: brandColors.tintsOffWhite40,
      },
      '&.OnLight': {
        color: brandColors.tintsNeutral20,
      },
    },
    swiperSlide: {
      width: 'fit-content',
      '&:not(:last-child)': {
        marginRight: spacing(3),
      },
    },
    navigation: {
      display: 'flex',
      justifyContent: 'center',
      gap: spacing(3),
      marginTop: spacing(2),
      cursor: 'pointer',
    },
    navigationButton: {
      width: 40,
      height: 40,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: typography.pxToRem(800),
      border: `${typography.pxToRem(1)} solid ${brandColors.primaryMain}`,
      '&.OnDark': {
        color: brandColors.white,
        borderColor: brandColors.white,
      },
      '&.OnLight': {
        color: brandColors.primaryMain,
      },
      [breakpoints.up('sm')]: {
        width: 60,
        height: 60,
      },
      '&:hover, &:focus': {
        backgroundColor: darkOrLightStyle(props)(
          brandColors.foregroundInverseSubtle,
          brandColors.interactiveHeroBlueSubtle
        ),
      },
    },
    navigationButtonDisabled: {
      opacity: 0.3,
    },
    hidden: {
      visibility: 'hidden',
    },
  })
);

export default useStyles;
